// client/src/v2/domains/home/home.api.js

/**
 * Home Location API (Frontend)
 * ----------------------------
 * Thin wrapper around backend geocode endpoint.
 *
 * IMPORTANT:
 * - Keep backwards-compatible exports while we refactor gradually.
 * - Use relative /api so CRA proxy handles localhost in dev.
 */

import { UI_MSG } from "../../config/uiMessages";

/**
 * Legacy-compatible function name (kept).
 *
 * @param {string} postcode
 * @returns {Promise<{ lat: number, lon: number }>}
 */
export async function fetchLatLonByPostcode(postcode) {
  const safe = encodeURIComponent(String(postcode || "").trim());
  const res = await fetch(`/api/geocode/postcode/${safe}`);

  if (res.status === 404) {
    const err = new Error(UI_MSG.POSTCODE_NOT_FOUND);
    err.code = 404;
    throw err;
  }

  if (res.status === 400) {
    const err = new Error(UI_MSG.POSTCODE_INVALID);
    err.code = 400;
    throw err;
  }

  if (!res.ok) {
    const err = new Error(UI_MSG.POSTCODE_LOOKUP_UNAVAILABLE);
    err.code = res.status;
    throw err;
  }

  const { lat, lon } = await res.json();
  return { lat, lon };
}

/**
 * New canonical name (alias) — use this going forward.
 */
export async function geocodePostcode(postcode) {
  return fetchLatLonByPostcode(postcode);
}
